var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableRow',_vm._l((_vm.structure),function(column,index){return _c('TableHead',{key:index,attrs:{"is-align-left":column.itemIds === 'hash',"is-highlight":column.itemIds === 'prize'}},[_vm._v(" "+_vm._s(column.header)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }